export default __webpack_public_path__ + "static/media/influencer.5369aaf7.svg";